import { NgModule } from '@angular/core';
import { JurisdictionPipe } from './jurisdiction.pipe';

@NgModule({
  declarations: [JurisdictionPipe],
  imports: [],
  exports: [JurisdictionPipe]
})
export class SharedPipesModule {}
